const getSeatMapSvg = (seatMapContainer) =>
  seatMapContainer && seatMapContainer.contentDocument && seatMapContainer.contentDocument.querySelector('svg');

export const getSeatMapContainer = (document, selector) => document.querySelector(selector);

export const reloadSeatMapContainer = (seatMapContainer) => {
  // Use this instead of seatMapContainer.contentWindow.location.reload()
  // to reload correctly in headless Chrome
  seatMapContainer.setAttribute('data', seatMapContainer.data);
};

export const onSeatMapContainerLoad = (seatMapContainer, callback) => {
  const seatMapSvg = getSeatMapSvg(seatMapContainer);

  if (!seatMapSvg) {
    seatMapContainer.addEventListener(
      'load',
      () => {
        const newSvgSeatMap = getSeatMapSvg(seatMapContainer);

        if (newSvgSeatMap) {
          callback(newSvgSeatMap);
        }
      },
      false
    );
  } else {
    callback(seatMapSvg);
  }
};
